import { UserManager } from 'oidc-client-ts'

// At most one silent sign-in at a time, across every UserManager in the app.
//
// Several paths renew the token, and after a longer pause they fire together: vuex-oidc's
// navigation guard starts a renew without waiting for it, its accessTokenExpiring handler may fire
// on wake-up, and the API client (plugins/axios.js) renews before sending a request. oidc-client-ts
// does not serialise these, so each would redeem the same refresh token. Authelia rotates refresh
// tokens, and redeeming one twice can count as reuse and end the session. Joining the call already
// in flight gives every caller the same renewed user.
//
// Patched on the prototype, not on an instance, because vuex-oidc creates its UserManager
// internally and does not expose it. The method is looked up at call time, so this only has to be
// evaluated before the first renew, which main.js ensures by importing it first.
const signinSilent = UserManager.prototype.signinSilent

let inFlight = null

UserManager.prototype.signinSilent = function signinSilentOnce(args) {
  if (!inFlight) {
    inFlight = signinSilent.call(this, args).finally(() => {
      inFlight = null
    })
  }
  return inFlight
}
